import { createApp, watch } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue, { usePrimeVue } from 'primevue/config';
import Aura from '@primevue/themes/aura';
import App from './App.vue';
import { router } from './router.js';
import { i18n } from './i18n.js';
import { primevueLocaleFor } from './lib/primevue-locale.js';
import 'primeicons/primeicons.css';
import './styles.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: { darkModeSelector: '.never-dark' },
  },
  locale: primevueLocaleFor(i18n.global.locale.value),
});

app.runWithContext(() => {
  const pv = usePrimeVue();
  watch(i18n.global.locale, (loc) => {
    Object.assign(pv.config.locale!, primevueLocaleFor(loc));
  });
});

app.mount('#app');
